// Author YuJiaBei
// Date 2022-04-24 09:16:26

class InspectionScheduleEquipment {
constructor({
        id = null,
        inspectionScheduleId = '',
        emArchBasicDataCode = '',
        order = '',
        description = ''}
= {}) {
    this.id = id;
    this.inspectionScheduleId = inspectionScheduleId;
    this.emArchBasicDataCode = emArchBasicDataCode;
    this.order = order;
    this.description = description;
}
}

function newEntity() {
return new InspectionScheduleEquipment();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'inspectionScheduleName',
        label: 'label.em.inspection.inspectionScheduleEquipment.grid.inspectionScheduleName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'emArchBasicDataName',
        label: 'label.em.inspection.inspectionScheduleEquipment.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'bdaCode',
        label: 'label.em.inspection.inspectionScheduleEquipment.grid.bdaCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'bdaSpecification',
        label: 'label.em.inspection.inspectionScheduleEquipment.grid.bdaSpecification',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'bdaModel',
        label: 'label.em.inspection.inspectionScheduleEquipment.grid.bdaModel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'order',
        label: 'label.em.inspection.inspectionScheduleEquipment.grid.order',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionScheduleEquipment.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    inspectionScheduleIdFilter : '',
    emArchBasicDataCodeFilter : '',
    orderFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'inspectionScheduleIdFilter',
        label: 'label.em.inspection.inspectionScheduleEquipment.filter.inspectionScheduleId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionSchedule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.inspection.inspectionScheduleEquipment.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'orderFilter',
        label: 'label.em.inspection.inspectionScheduleEquipment.filter.order',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'inspectionScheduleId',
        label: 'label.em.inspection.inspectionScheduleEquipment.entity.inspectionScheduleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'inspectionSchedule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.inspection.inspectionScheduleEquipment.entity.emArchBasicDataCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'order',
        label: 'label.em.inspection.inspectionScheduleEquipment.entity.order',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionScheduleEquipment.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
]

export {InspectionScheduleEquipment, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
